import { render, staticRenderFns } from "./ArchivedDealStreamItem.vue?vue&type=template&id=021e4b09"
import script from "./ArchivedDealStreamItem.vue?vue&type=script&lang=js"
export * from "./ArchivedDealStreamItem.vue?vue&type=script&lang=js"
import style0 from "./ArchivedDealStreamItem.vue?vue&type=style&index=0&id=021e4b09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports